import {
    validateEmail,
    validateName,
    validatePhone,
    validateMessage,
    containsSqlInjection,
    containsXss,
    containsCodeInjection,
} from '../../../../context-module/context-configuration/permission-provider/validation/index';

export const validateBusinessField = (name: string, value: string): string => { //NOSONAR
    // Check for injection attacks
    if (containsSqlInjection(value) || containsXss(value) || containsCodeInjection(value)) { //NOSONAR
        return 'Input contains potentially dangerous content';
    }

    switch (name) { //NOSONAR
        case 'businessName': {
            const result = validateName(value, 'Business name');
            return result.errors.length > 0 ? result.errors[0] : ''; //NOSONAR
        }
        case 'businessEmail': {
            const result = validateEmail(value);
            return result.errors.length > 0 ? result.errors[0] : ''; //NOSONAR
        }
        case 'phone': {
            if (value) { //NOSONAR
                const result = validatePhone(value);
                return result.errors.length > 0 ? result.errors[0] : ''; //NOSONAR
            }
            return '';
        }
        case 'message': {
            if (value) { //NOSONAR
                const result = validateMessage(value, 300);
                return result.errors.length > 0 ? result.errors[0] : ''; //NOSONAR
            }
            return '';
        }
        default:
            return '';
    }
};
